export const TopicBuilder = {
    CompanyGeneral: (companyId) => `COMPANY_${companyId}_GENERAL`,
    CommsMessage: (companyId) => `COMPANY_${companyId}_COMMS_MESSAGE`,
    IncidentStatus: (companyId) => `COMPANY_${companyId}_INCIDENT_STATUS`,
    IncidentAck: (companyId) => `COMPANY_${companyId}_INCIDENT_ACK`,
    UnitStatus: (companyId) => `COMPANY_${companyId}_UNIT_STATUS`,
    UnitWeather: (companyId) => `COMPANY_${companyId}_UNIT_WEATHER`,
    AMTIncident: (companyId) => `COMPANY_${companyId}_AMT_INCIDENT`,
    Q15Status: (companyId) => `COMPANY_${companyId}_Q15`,
    CallRequestChange: (companyId) => `COMPANY_${companyId}_CALLREQ`,
};
//# sourceMappingURL=topicbuilder.js.map